const DEFAULT_STRAPI_PUBLIC_URL = "http://localhost:1337";

function getStrapiPublicUrl() {
	// Used for building absolute media URLs. This is safe to be "public"
	// since it is just the origin, not the API token.
	const raw = import.meta.env.VITE_STRAPI_URL?.trim() || DEFAULT_STRAPI_PUBLIC_URL;
	const normalized = raw.replace(/\/$/, "");

	// People often (reasonably) set STRAPI_URL to `http://host:1337/api`.
	// Media URLs are served from `/uploads`, so we must ensure this is the origin only.
	try {
		const parsed = new URL(normalized);
		return parsed.origin;
	} catch {
		// Fallback for non-standard values: remove a trailing `/api` if present.
		return normalized.replace(/\/api$/, "");
	}
}

export function strapiMediaUrl(url) {
	if (!url) return undefined;

	// Strapi media is typically served from `/uploads/...`.
	// Some setups (or misconfigurations) return `/api/uploads/...` — normalize it.
	const normalizePath = (u) => (u.startsWith("/api/uploads/") ? u.replace(/^\/api/, "") : u);

	if (url.startsWith("http://") || url.startsWith("https://")) {
		try {
			const parsed = new URL(url);
			parsed.pathname = normalizePath(parsed.pathname);
			return parsed.toString();
		} catch {
			return url;
		}
	}

	const base = getStrapiPublicUrl();
	const path = normalizePath(url.startsWith("/") ? url : `/${url}`);
	return `${base}${path}`;
}

